import IPickListViewOptions from "../../models/IPickListViewOptions";
import IViewOptions from "../../models/IViewOptions";
import ControlTypeEnum from "../../models/ControlTypeEnum";
import { useMemo } from "react";

export const usePickListViewOptionsUI = (view: IPickListViewOptions) => {
    const viewOptions: IViewOptions[] = useMemo(() => {
        return [
            {
                title: "show_sku",
                prop: "showSku",
                type: ControlTypeEnum.checkbox,
                value: view.showSku,
            },
            {
                title: "show_item_name",
                prop: "showItemName",
                type: ControlTypeEnum.checkbox,
                value: view.showItemName,
            },
            {
                title: "show_description",
                prop: "showDescription",
                type: ControlTypeEnum.checkbox,
                value: view.showDescription,
            },
            {
                title: "show_item_options",
                prop: "showItemOptions",
                type: ControlTypeEnum.checkbox,
                value: view.showItemOptions,
            },
            {
                title: "show_control",
                prop: "showControl",
                type: ControlTypeEnum.checkbox,
                value: view.showControl,
            },
            {
                title: "show_item_location",
                prop: "showItemLocation",
                type: ControlTypeEnum.checkbox,
                value: view.showItemLocation,
            },
            {
                title: "group_by_root_category",
                prop: "groupByRootCategory",
                type: ControlTypeEnum.checkbox,
                value: view.groupByRootCategory,
            },
            {
                title: "customer_matrix_layout",
                prop: "customerMatrixLayout",
                type: ControlTypeEnum.checkbox,
                value: view.customerMatrixLayout,
            },
            {
                title: "show_customer_name",
                prop: "showCustomerName",
                type: ControlTypeEnum.checkbox,
                value: view.showCustomerName,
            },
            {
                title: "show_order_user",
                prop: "showOrderUser",
                type: ControlTypeEnum.checkbox,
                value: view.showOrderUser,
            },
            {
                title: "show_delivery_date",
                prop: "showDeliveryDate",
                type: ControlTypeEnum.checkbox,
                value: view.showDeliveryDate,
            },
            {
                title: "show_page_numbers",
                prop: "showPageNumbers",
                type: ControlTypeEnum.checkbox,
                value: view.showPageNumbers,
            },
            {
                title: "show_printed_date",
                prop: "showPrintedDate",
                type: ControlTypeEnum.checkbox,
                value: view.showPrintedDate,
            },
            {
                title: "show_uom",
                prop: "showUom",
                type: ControlTypeEnum.checkbox,
                value: view.showUom,
            },
            {
                title: "repeat_order_header",
                prop: "repeatOrderHeader",
                type: ControlTypeEnum.checkbox,
                value: view.repeatOrderHeader,
            },
            {
                title: "print_landscape",
                prop: "landscape",
                type: ControlTypeEnum.checkbox,
                value: view.landscape,
            },
        ];
    }, [view]);

    return viewOptions;
};
